export default __webpack_public_path__ + "static/media/title.364b2cfd.svg";